import { createAuthClient } from "better-auth/react";
import { twoFactorClient } from "better-auth/client/plugins";

export interface CreateOptrixisAuthClientOptions {
  baseURL?: string;
  twoFactorPage?: string;
}

export function createOptrixisAuthClient(options: CreateOptrixisAuthClientOptions = {}) {
  return createAuthClient({
    ...(options.baseURL ? { baseURL: options.baseURL } : {}),
    plugins: [
      twoFactorClient({
        twoFactorPage: options.twoFactorPage ?? "/two-factor",
      }),
    ],
  });
}

export type OptrixisAuthClient = ReturnType<typeof createOptrixisAuthClient>;
